// src/components/Logs/LogDetailModal.jsx
import React from "react";

const LogDetailModal = ({ log, onClose }) => {
  if (!log) return null;

  const getLogTypeColor = (type) => {
    const colors = {
      API_CALL: "#3498db",
      USER_ACTION: "#2ecc71",
      AUTOMATION_EXECUTION: "#f39c12",
      INTEGRATION_EVENT: "#9b59b6",
      ERROR: "#e74c3c",
      SECURITY_EVENT: "#e67e22",
    };
    return colors[type] || "#95a5a6";
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "N/A";
    const date = new Date(timestamp);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          width: "90%",
          maxWidth: "700px",
          maxHeight: "80vh",
          overflow: "auto",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            padding: "20px",
            borderBottom: "1px solid #e0e0e0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 style={{ margin: 0, fontSize: "20px" }}>Audit Log Details</h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              color: "#7f8c8d",
            }}
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: "20px" }}>
          {/* Log Type Badge */}
          <div style={{ marginBottom: "20px" }}>
            <span
              style={{
                display: "inline-block",
                padding: "6px 12px",
                borderRadius: "4px",
                fontSize: "14px",
                fontWeight: "500",
                background: getLogTypeColor(log.log_type) + "20",
                color: getLogTypeColor(log.log_type),
              }}
            >
              {log.log_type}
            </span>
          </div>

          {/* Details Grid */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr",
              gap: "15px",
            }}
          >
            <div>
              <div style={{ fontWeight: "bold", fontSize: "12px", color: "#7f8c8d", marginBottom: "5px" }}>
                ID
              </div>
              <div style={{ fontSize: "14px", fontFamily: "monospace" }}>{log.id}</div>
            </div>

            <div>
              <div style={{ fontWeight: "bold", fontSize: "12px", color: "#7f8c8d", marginBottom: "5px" }}>
                Timestamp
              </div>
              <div style={{ fontSize: "14px" }}>{formatTimestamp(log.timestamp)}</div>
            </div>

            <div>
              <div style={{ fontWeight: "bold", fontSize: "12px", color: "#7f8c8d", marginBottom: "5px" }}>
                Action
              </div>
              <div style={{ fontSize: "14px", fontWeight: "500" }}>{log.action}</div>
            </div>

            <div>
              <div style={{ fontWeight: "bold", fontSize: "12px", color: "#7f8c8d", marginBottom: "5px" }}>
                User ID
              </div>
              <div style={{ fontSize: "14px" }}>{log.user_id || "System"}</div>
            </div>

            {log.entity_type && (
              <div>
                <div style={{ fontWeight: "bold", fontSize: "12px", color: "#7f8c8d", marginBottom: "5px" }}>
                  Entity Type
                </div>
                <div style={{ fontSize: "14px" }}>{log.entity_type}</div>
              </div>
            )}

            {log.entity_id && (
              <div>
                <div style={{ fontWeight: "bold", fontSize: "12px", color: "#7f8c8d", marginBottom: "5px" }}>
                  Entity ID
                </div>
                <div style={{ fontSize: "14px", fontFamily: "monospace" }}>{log.entity_id}</div>
              </div>
            )}

            {log.description && (
              <div>
                <div style={{ fontWeight: "bold", fontSize: "12px", color: "#7f8c8d", marginBottom: "5px" }}>
                  Description
                </div>
                <div style={{ fontSize: "14px", lineHeight: "1.6" }}>{log.description}</div>
              </div>
            )}

            {log.ip_address && (
              <div>
                <div style={{ fontWeight: "bold", fontSize: "12px", color: "#7f8c8d", marginBottom: "5px" }}>
                  IP Address
                </div>
                <div style={{ fontSize: "14px", fontFamily: "monospace" }}>{log.ip_address}</div>
              </div>
            )}

            <div>
              <div style={{ fontWeight: "bold", fontSize: "12px", color: "#7f8c8d", marginBottom: "5px" }}>
                Workspace ID
              </div>
              <div style={{ fontSize: "14px" }}>{log.workspace_id}</div>
            </div>

            {log.metadata && Object.keys(log.metadata).length > 0 && (
              <div>
                <div style={{ fontWeight: "bold", fontSize: "12px", color: "#7f8c8d", marginBottom: "5px" }}>
                  Metadata
                </div>
                <pre
                  style={{
                    background: "#2c3e50",
                    color: "#ecf0f1",
                    padding: "15px",
                    borderRadius: "4px",
                    overflow: "auto",
                    fontSize: "12px",
                    fontFamily: "monospace",
                    margin: 0,
                  }}
                >
                  {JSON.stringify(log.metadata, null, 2)}
                </pre>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "15px 20px",
            borderTop: "1px solid #e0e0e0",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 20px",
              background: "#3498db",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogDetailModal;
